import React from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from './ui/sheet';
import { Button } from './ui/button';
import { Minus, Plus, Trash2, ShoppingBag, Truck } from 'lucide-react';
import { useStore } from '../context/StoreContext';
import { CURRENCY } from '../mock/mock';

const CartDrawer = ({ open, onClose, onCheckout }) => {
  const { cartDetailed, totals, updateQty, removeFromCart, settings } = useStore();
  const empty = cartDetailed.length === 0;

  return (
    <Sheet open={open} onOpenChange={(o) => !o && onClose()}>
      <SheetContent className="w-full sm:max-w-md flex flex-col p-0">
        <SheetHeader className="px-6 py-5 border-b border-border">
          <SheetTitle className="flex items-center gap-2 font-display">
            <ShoppingBag className="h-5 w-5 text-primary" /> Your Cart
          </SheetTitle>
        </SheetHeader>

        {empty ? (
          <div className="flex-1 flex flex-col items-center justify-center text-center px-6">
            <div className="h-20 w-20 rounded-full bg-secondary flex items-center justify-center mb-4">
              <ShoppingBag className="h-8 w-8 text-muted-foreground" />
            </div>
            <p className="font-semibold text-foreground">Your cart is empty</p>
            <p className="text-sm text-muted-foreground mt-1">Add some sparkling clean products!</p>
            <Button onClick={onClose} className="mt-5 bg-primary hover:bg-primary/90 text-white">Browse Products</Button>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto px-6 py-4 space-y-4">
              {cartDetailed.map((line) => (
                <div key={line.id} className="flex gap-3 border border-border rounded-xl p-3">
                  <div className="h-20 w-20 bg-secondary/40 rounded-lg flex items-center justify-center shrink-0 p-1.5">
                    <img src={line.product.image} alt={line.product.name} className="h-full w-auto object-contain" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex justify-between gap-2">
                      <p className="font-semibold text-sm text-foreground leading-tight">{line.product.name}</p>
                      <button onClick={() => removeFromCart(line.id)} className="text-muted-foreground hover:text-[#e11d1d]">
                        <Trash2 className="h-4 w-4" />
                      </button>
                    </div>
                    <p className="text-xs text-muted-foreground">{line.product.size} pack</p>
                    <div className="mt-2 flex items-center justify-between">
                      <div className="flex items-center border border-border rounded-full">
                        <button className="px-2 py-1 hover:text-primary" onClick={() => updateQty(line.id, line.qty - 1)}><Minus className="h-3.5 w-3.5" /></button>
                        <span className="w-7 text-center text-sm font-semibold">{line.qty}</span>
                        <button className="px-2 py-1 hover:text-primary" onClick={() => updateQty(line.id, Math.min(line.product.stock, line.qty + 1))}><Plus className="h-3.5 w-3.5" /></button>
                      </div>
                      <span className="font-display font-bold text-foreground">{CURRENCY}{line.lineTotal}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="border-t border-border px-6 py-5 space-y-3 bg-secondary/20">
              {totals.savings > 0 && (
                <div className="flex justify-between text-sm text-[#159a3b] font-medium">
                  <span>You save</span><span>-{CURRENCY}{totals.savings}</span>
                </div>
              )}
              <div className="flex justify-between text-sm text-muted-foreground">
                <span>Subtotal</span><span className="text-foreground font-medium">{CURRENCY}{totals.subtotal}</span>
              </div>
              <div className="flex justify-between text-sm text-muted-foreground">
                <span className="flex items-center gap-1.5"><Truck className="h-4 w-4" /> Shipping</span>
                <span className="text-foreground font-medium">{totals.shipping === 0 ? 'FREE' : `${CURRENCY}${totals.shipping}`}</span>
              </div>
              {totals.shipping > 0 && (
                <p className="text-xs text-muted-foreground">Add {CURRENCY}{settings.freeShippingAbove - totals.subtotal} more for free shipping.</p>
              )}
              <div className="flex justify-between font-display font-extrabold text-lg pt-2 border-t border-border">
                <span>Total</span><span className="text-primary">{CURRENCY}{totals.total}</span>
              </div>
              <Button onClick={onCheckout} className="w-full bg-primary hover:bg-primary/90 text-white font-semibold py-6 mt-2">
                Checkout · Cash on Delivery
              </Button>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
};

export default CartDrawer;
